/* tslint:disable */
/* eslint-disable */
/**
 * Its4Plan PDF Service
 * Its4Plan PDF Service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetCompanySummaryRequest {
    startDate: Date;
    endDate: Date;
    employeeIds: string;
    additionalHours?: number;
}

/**
 * 
 */
export class CompanySummaryApi extends runtime.BaseAPI {

    /**
     */
    async getCompanySummaryRaw(requestParameters: GetCompanySummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling getCompanySummary().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling getCompanySummary().'
            );
        }

        if (requestParameters['employeeIds'] == null) {
            throw new runtime.RequiredError(
                'employeeIds',
                'Required parameter "employeeIds" was null or undefined when calling getCompanySummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = (requestParameters['startDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = (requestParameters['endDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['additionalHours'] != null) {
            queryParameters['additional_hours'] = requestParameters['additionalHours'];
        }

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employee_ids'] = requestParameters['employeeIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_summary/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getCompanySummary(requestParameters: GetCompanySummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getCompanySummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
